import * as React from "react";

function AryztaIcon(props) {
  const { className, height, width } = props;
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 109 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 21.32383,21.997559 H 17.059181 L 15.952736,18.76416 H 10.023048 L 8.9166031,21.997559 H 4.7593765 L 10.66758,6.0024414 h 4.748047 z m -6.370118,-6.166016 -1.96582,-5.736328 -1.96582,5.736328 z m 18.078673,-4.930664 q 0,-0.601563 -0.24707,-1.0312501 Q 32.538244,9.4399414 31.936682,9.1928711 31.517736,9.0209961 30.959143,8.9887695 30.400549,8.9458008 29.659338,8.9458008 h -1.493164 v 4.3076172 h 1.267578 q 0.988281,0 1.654297,-0.09668 0.666016,-0.09668 1.117187,-0.440429 0.429688,-0.333008 0.623047,-0.730469 0.204102,-0.408203 0.204102,-1.084961 z m 6.43457,11.09668 h -5.038086 l -4.361328,-5.865235 h -1.901367 v 5.865235 H 24.062658 V 6.0024414 h 6.917969 q 1.417969,0 2.438477,0.1611328 1.020507,0.1611328 1.912109,0.6982422 0.902344,0.5371094 1.428711,1.3964844 0.537109,0.8486328 0.537109,2.1376952 0,1.772461 -0.827148,2.889649 -0.816406,1.117187 -2.341797,1.858398 z M 55.783909,6.0024414 49.886448,15.810059 v 6.1875 h -4.125 V 16.003418 L 39.767307,6.0024414 h 4.683594 l 3.458984,6.1874996 3.340821,-6.1874996 z M 70.725861,21.997559 H 57.287384 v -2.997071 l 7.970703,-9.9042966 h -7.583984 v -3.09375 h 12.62207 v 3.0507813 l -7.959961,9.8505863 h 8.389649 z M 86.537933,9.0961914 H 81.542816 V 21.997559 h -4.125 V 9.0961914 h -4.995117 v -3.09375 H 86.537933 Z M 104.24062,21.997559 H 99.975975 L 98.86953,18.76416 h -5.929688 l -1.106445,3.233399 H 87.67617 L 93.584373,6.0024414 h 4.748047 z m -6.370114,-6.166016 -1.96582,-5.736328 -1.96582,5.736328 z"
        fill="#843d1d"
        aria-label="ARYZTA"
      />
    </svg>
  );
}

export default AryztaIcon;
